(() => {
  if (window.morkasCartSocksInitialized) return;
  window.morkasCartSocksInitialized = true;

  const updateArrows = (track) => {
    const section = track.closest('[data-cart-sock-upsell]');
    if (!section) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    section.querySelector('[data-cart-sock-direction="previous"]').disabled = track.scrollLeft <= 2;
    section.querySelector('[data-cart-sock-direction="next"]').disabled = track.scrollLeft >= maxScroll - 2;
  };

  const initialize = () => {
    document.querySelectorAll('[data-cart-sock-track]').forEach((track) => {
      if (track.dataset.carouselReady) return;
      track.dataset.carouselReady = 'true';
      track.addEventListener('scroll', () => updateArrows(track), { passive: true });
      updateArrows(track);
    });
  };

  const watchDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    initialize();
    new MutationObserver(initialize).observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-cart-sock-track]').forEach(updateArrows);
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-cart-sock-direction]');
    if (!arrow) return;
    const track = arrow.closest('[data-cart-sock-upsell]')?.querySelector('[data-cart-sock-track]');
    const firstCard = track?.querySelector('.morkas-cart-socks__item');
    if (!firstCard) return;
    const step = firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    track.scrollBy({
      left: arrow.dataset.cartSockDirection === 'next' ? step : -step,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-sock-add]');
    if (!button) return;
    const section = button.closest('[data-cart-sock-upsell]');
    if (button.disabled || section?.getAttribute('aria-busy') === 'true') return;
    const drawer = button.closest('cart-drawer');
    const status = section.querySelector('[data-cart-sock-status]');
    const id = Number(button.dataset.variantId);
    if (!drawer || !id) return;

    button.disabled = true;
    section.setAttribute('aria-busy', 'true');
    status.textContent = 'Agregando calcetas…';
    let failureMessage = 'No pudimos confirmar si se agregó. Revisa tu carrito antes de intentar de nuevo.';
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: drawer.getSectionsToRender().map((item) => item.id),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status || !result.sections) {
        failureMessage = typeof result.description === 'string' ? result.description : 'No se pudieron agregar las calcetas. Inténtalo de nuevo.';
        throw new Error('CART_SOCK_ADD_FAILED');
      }
      result.id = id;
      document.dispatchEvent(new CustomEvent('cart:change', { detail: result, bubbles: true }));
      drawer.setActiveElement(document.querySelector('#cart-icon-bubble') || button);
      drawer.renderContents(result);
    } catch (error) {
      status.textContent = failureMessage;
      button.disabled = false;
      section.removeAttribute('aria-busy');
    }
  });
})();
